export function filterCaseInsensitiveNoSymbol(filter: any, row: any, regex?: any) {
    const id = filter.pivotId || filter.id;
    if (row[id] != null) {
        const rgx = regex || /[\W_]+/g;
        let val = row[id].toString().toLowerCase();
        val = val.replace(rgx, " ");
        return val.includes(filter.value.toLowerCase());
    } else {
        return true;
    }
}